import FilteringOverview from '../FilteringOverview.vue';
import FilteringConfig from '../FilteringConfig.vue';
import GainMidBatchApiImportFiles from '../GainMidBatchApiImportFiles.vue';

export default {
  path: '/mid-batch-api',
  name: 'MidBatchApi',
  redirect: { name: 'MidBatchApiConfig' },
  component: FilteringOverview,
  meta: { menuItemName: 'MidBatchApi' },
  children: [
    {
      path: 'config',
      name: 'MidBatchApiConfig',
      component: FilteringConfig
    },
    {
      path: 'api-files',
      name: 'GainMidBatchApiImportFiles',
      component: GainMidBatchApiImportFiles
    }
  ]
};
